
export class DefaultRegistry {

  addMinutes(thisDatetime: Date, functionContext: any): Date {
    const { minutes } = functionContext;
    const adaptedDatetime = new Date(thisDatetime.getTime() + minutes*60*1000)
    return adaptedDatetime
  }

  getFunction(functionName: string){
    const map: Record<string, Function> = {
      $$addMinutes: this.addMinutes.bind(this)
    }

    const thisFunction = map[functionName];
    if (!thisFunction) {
      throw new Error(`Function ${functionName} not found in registry`);
    }

    return thisFunction
  }
}

export const defaultRegistry = new DefaultRegistry();
